// 1. Definisci il tuo CSS personalizzato
const customCSS = `
  ._inline_1q1d2_47 ._formContainer_1q1d2_30 {
  max-width:640px !important;
  }
  div._formFieldContainer_1mxsl_5 {
    width: 100% !important;
  }
  ._formFieldset_cit2d_82 {
    flex-direction:row !important;
  }
 input._formInputField_nag3b_7 {
  margin-bottom: 2px !important;
  display: block;
  border: 0 !important;
  border-bottom: 1px solid #777 !important;
  background-color: transparent !important;
  border-radius: 0 !important;
  font-size: 14px;
  box-shadow: none !important;
}
button._formSubmitButton_cit2d_96 {
  border-radius: 0;
  text-transform: uppercase;
  padding: 18px 40px;
  margin-bottom: 2px !important;
  width: 120px !important;
}
div._formDisclaimer_cit2d_38 {padding-left:14px !important;}
`;

// 2. Crea un Constructable Stylesheet
const customSheet = new CSSStyleSheet();
customSheet.replaceSync(customCSS);

// 3. Funzione per iniettare il foglio di stile
function applyCustomStylesToShadowDOM(formElement) {
  if (formElement.shadowRoot) {
    // Aggiunge il nostro foglio di stile all'array degli stylesheet esistenti
    formElement.shadowRoot.adoptedStyleSheets = [
      ...formElement.shadowRoot.adoptedStyleSheets,
      customSheet
    ];
    console.log('Stili personalizzati applicati con successo allo Shadow DOM!');
  } else {
    console.warn('Lo shadowRoot non è ancora accessibile per questo elemento.');
  }
}

// 4. Logica di ricerca e osservazione
const targetSelector = '#app-embed';

// Prima di tutto, controlla se l'elemento è già presente nel DOM (nel caso carichi in fretta)
const existingForm = document.querySelector(targetSelector);
//console.log('YYY');
if (existingForm && existingForm.shadowRoot) {
  applyCustomStylesToShadowDOM(existingForm);
} else {
    //console.log('YYY');
  // Se non c'è, avvia il MutationObserver per attendere il caricamento dinamico
  const observer = new MutationObserver((mutations, obs) => {
    // Cerchiamo il form-embed ad ogni mutazione rilevante
    const formElement = document.querySelector(targetSelector);
    console.log('ZZZ');
    // Controlliamo che esista e che lo shadowRoot sia stato inizializzato
    if (formElement && formElement.shadowRoot) {
      applyCustomStylesToShadowDOM(formElement);
      obs.disconnect(); // Ferma l'observer per non consumare risorse inutilmente
    }
  });

  // Osserva il body (e tutti i suoi figli) in cerca di nuovi nodi aggiunti
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}